import DonationCriteria from '@/core/components/DonationDetails/DonationCriteria/DonationCriteria';

export default DonationCriteria;
